import { Image as AntdImage } from "antd"
const Image = props => {
  return <AntdImage {...props}></AntdImage>
}

export default Image
